import React, { Component } from 'react';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import laundroLogo from '../../../assets/images/logo/laundroLogo.png';
import wasshupLogo from '../../../assets/images/logo/washupLogo.png';
import cleanproLogo from '../../../assets/images/logo/cleanproqrlogo.png';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { connect } from 'react-redux';
import axios from 'axios';

import { updateTheme } from '../../../redux/actions/distributorActions';
import Loading from '../../admin/components/Loading';

import i18n from "i18next";
import { getStoreType } from '../../../dynamicController';

const mySwal = withReactContent(Swal);

const STORETYPE = getStoreType()

const buttonColors = {
    redTheme: {
        backgroundColor: "red",
        border: "5px white solid",
    },
    pink: {
        backgroundColor: "#ff9bb5",
        border: "5px white solid"
    },
    lightBlue: {
        backgroundColor: "#76baff",
        border: "5px white solid"
    },
    purple: {
        backgroundColor: "#944dd3",
        border: "5px white solid"
    },
    orangeTheme: {
        backgroundColor: "#ff5a00",
        border: "5px white solid"
    },
    yellow: {
        backgroundColor: "yellow",
        border: "5px white solid"
    },
    lime: {
        backgroundColor: "#ccff90",
        border: "5px white solid"
    },
    blue: {
        backgroundColor: "#1a74e2",
        border: "5px white solid"
    },
    lightPurple: {
        backgroundColor: "#8232fa",
        border: "5px white solid"
    },
    green: {
        backgroundColor: "#1e5631",
        border: "5px white solid"
    },
    nannybee: {
        backgroundColor: "#E3A269",
        border: "5px white solid"
    },
    bubblesYellow: {
        backgroundColor: "#fad719",
        border: "5px white solid"
    },
    jomcuci: {
        backgroundColor: "#7F1416",
        border: "5px white solid"
    }
};


class Customize extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: false,
            selected: "default-theme",
            logo: "laundroLogo",
            loading: false,
            distributorId: "",
            data: null
        };
    };

    componentDidMount() {
        if (!this.props.client || !this.props.client.customize_color) {
            return this.props.history.push('/client');
        }
    };

    handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

    handleSelectDistributor = (e) => {
        let sendThis = {
            distributorId: e.target.value
        }

        this.setState({
            ...this.state,
            loading: true,
            distributorId: e.target.value
        });

        axios.post('/api/distributor/setting/getColorSettings', sendThis, { headers: { "Content-Type": "application/json", "auth-token": this.props.token } })
            .then(res => {
                this.setState({
                    ...this.state,
                    loading: false,
                    selected: res.data.className,
                    logo: res.data.logo,
                    data: res.data
                });
            })
            .catch(err => {
                this.setState({
                    ...this.state,
                    loading: false
                });
                mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error");
            });
    }

    handleImage = e => {
        const logo = e.target.files[0];

        const imageRegex = /image\//g;
        const jpgRegex = /.jpg/g;
        const pngRegex = /.png/g;
        const jpegRegex = /.jpeg/g;

        if (imageRegex.test(logo.type) && !jpgRegex.test(logo.name) && !pngRegex.test(logo.name) && !jpegRegex.test(logo.name)) {
            e.target.value = null;
            e.target.files = [];
            this.setState({
                ...this.state,
                logo: "laundroLogo"
            });
            mySwal.fire(i18n.t("Info"), i18n.t("Please only use image type file"), "info");
        } else {
            this.setState({
                ...this.state,
                logo
            });
        }
    };

    handleReset = e => {
        this.setState({
            ...this.state,
            logo: "laundroLogo"
        });
    };

    handleDefaultTheme = e => {
        STORETYPE === "washup" ?
            this.setState({
                ...this.state,
                selected: "washup-theme"
            }) : STORETYPE === "cleanpro" ?
                this.setState({
                    ...this.state,
                    selected: "cleanpro-theme"
                }) : this.setState({
                    ...this.state,
                    selected: "default-theme"
                })
    }

    handleSubmit = e => {
        e.preventDefault();

        const { selected, logo, distributorId } = this.state;

        if (selected !== this.state.data.className || logo !== this.state.data.logo) {
            const formData = new FormData();
            formData.append("id", distributorId);
            formData.append("role", "distributor");
            formData.append("className", selected);
            formData.append("logo", logo);

            this.setState({
                ...this.state,
                loading: true
            });
            axios.post('/api/admin/setting/customize', formData, { headers: { "auth-token": this.props.token } })
                .then(res => {
                    this.setState({
                        ...this.state,
                        loading: false,
                        data: res.data.theme
                    });

                    this.props.updateTheme(res.data.theme);
                    mySwal.fire(i18n.t("Success"), i18n.t("Your theme has been updated successfully"), "success");
                })
                .catch(err => {
                    this.setState({
                        ...this.state,
                        loading: false
                    });
                    mySwal.fire(i18n.t("Error"), i18n.t(err.response.data.error), "error")
                });
        }
    };

    render() {
        const renderLogo = () => {
            return this.state.logo === "laundroLogo" && STORETYPE === "washup" ? wasshupLogo :
                this.state.logo === "laundroLogo" && STORETYPE === "cleanpro" ? cleanproLogo :
                    this.state.logo === "laundroLogo" ? laundroLogo :
                        typeof this.state.logo === "string" ? this.state.logo :
                            URL.createObjectURL(this.state.logo);
        };

        return (
            <div className="admin-page-container">
                <Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />

                <div className="admin-page">
                    <Topbar handleToggle={this.handleToggle} />

                    <div className="admin-content">

                        <div className="text-center">
                            <h3>{i18n.t("Customize Color")}</h3>
                        </div>
                        <div className="pb-2">
                            <label htmlFor="distributorId">{i18n.t("Select Distributor")}: </label>
                            <select id="distributorId" name="distributorId" className="browser-default form-select" value={this.state.distributorId} onChange={this.handleSelectDistributor}>
                                <option disabled value="">{i18n.t("Select Distributor")}</option>
                                {
                                    this.props.client.distributor.map(distributor => <option key={distributor.id} value={distributor.id}>{distributor.name}</option>)
                                }
                            </select>
                        </div>
                        {
                            this.state.data && !this.state.loading ? (
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title">{i18n.t("Customize Color")}</h5>
                                    </div>

                                    <div className="card-body">
                                        <div>
                                            <div id="preview-container">
                                                {/* color preview */}
                                                <div id="color-preview" className={this.state.selected}>
                                                    {/* container */}
                                                    <div id="preview-header">
                                                        {/* header */}
                                                        <img src={renderLogo()} alt="preview logo" className="img-fluid" />
                                                    </div>

                                                    <div id="preview-body">
                                                        {/* body */}
                                                        <p className="font-weight-bold">{i18n.t("WELCOME")}</p>
                                                        <div className="d-flex flex-column px-5 mt-4">
                                                            <button type="button" id="preview-register-btn" className="btn form-control mb-1">{i18n.t("REGISTER")}</button>
                                                            <button type="button" id="preview-login-btn" className="btn form-control">{i18n.t("LOGIN")}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="colors-container">
                                                <div id="colors-holder">
                                                    {/* color selections */}
                                                    {/* jomcuci theme */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "jomcuci-theme" })} style={buttonColors.jomcuci} className="color-button">
                                                        {
                                                            this.state.selected === "jomcuci-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* nanny bee theme */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "nannybee-theme" })} style={buttonColors.nannybee} className="color-button">
                                                        {
                                                            this.state.selected === "nannybee-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* red, white */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "red-theme" })} style={buttonColors.redTheme} className="color-button">
                                                        {
                                                            this.state.selected === "red-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* orange, lightyellow */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "orange-theme" })} style={buttonColors.orangeTheme} className="color-button">
                                                        {
                                                            this.state.selected === "orange-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* lightgreen, darkgreen */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "green-theme" })} style={buttonColors.green} className="color-button">
                                                        {
                                                            this.state.selected === "green-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* blue + white */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "blue-theme" })} style={buttonColors.blue} className="color-button">
                                                        {
                                                            this.state.selected === "blue-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* purple, white */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "purple-theme" })} style={buttonColors.purple} className="color-button">
                                                        {
                                                            this.state.selected === "purple-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* pink. white */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "pink-theme" })} style={buttonColors.pink} className="color-button">
                                                        {
                                                            this.state.selected === "pink-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* yellow + white */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "yellow-theme" })} style={buttonColors.yellow} className="color-button">
                                                        {
                                                            this.state.selected === "yellow-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* green + light */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "lime-theme" })} style={buttonColors.lime} className="color-button">
                                                        {
                                                            this.state.selected === "lime-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* blue + light */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "lightBlue-theme" })} style={buttonColors.lightBlue} className="color-button">
                                                        {
                                                            this.state.selected === "lightBlue-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* purple + light */}
                                                    <div onClick={e => this.setState({ ...this.state, selected: "lightPurple-theme" })} style={buttonColors.lightPurple} className="color-button">
                                                        {
                                                            this.state.selected === "lightPurple-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>

                                                    {/* Bubbles Yellow Theme */}
                                                    <div
                                                        onClick={e => this.setState({ ...this.state, selected: "bubbles-yellow-theme" })}
                                                        style={buttonColors.bubblesYellow}
                                                        className="color-button"
                                                    >
                                                        {
                                                            this.state.selected === "bubbles-yellow-theme"
                                                                ? (
                                                                    <span className="color-check">
                                                                        <i className="fas bi-check-lg"></i>
                                                                    </span>
                                                                )
                                                                : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="text-center">
                                                <button type="button" className={this.state.selected === "default-theme" ? "btn btn-success mx-auto mt-2 btn-block font-weight-bold" : "btn btn-secondary mx-auto mt-2 btn-block"} style={{ maxWidth: "600px" }} onClick={this.handleDefaultTheme}>{i18n.t("Default Theme")}</button>
                                            </div>

                                            <form className="mt-4" onReset={this.handleReset} onSubmit={this.handleSubmit}>
                                                <div className="form-group" style={{ position: "relative" }}>
                                                    <label className="ms-3" htmlFor="logo">{i18n.t("Change Logo")}</label>
                                                    <input type="file" accept="image/*" id="logo" name="logo" className="form-control m-0 p-0" onChange={this.handleImage} />
                                                </div>

                                                <div>
                                                    <input type="reset" value={i18n.t("REMOVE LOGO")} className="btn btn-secondary form-control mb-1" />
                                                    {
                                                        this.state.loading
                                                            ? (
                                                                <div className="text-center">
                                                                    <div className="spinner-border text-primary">
                                                                        <span className="sr-only">Loading...</span>
                                                                    </div>
                                                                </div>
                                                            )
                                                            : <input type="submit" value={i18n.t("SUBMIT")} className="btn btn-primary mt-1 form-control font-weight-bold" />
                                                    }

                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            ) : this.state.loading ? <Loading />
                                : null
                        }

                    </div>
                </div>
            </div>
        );
    };
};

const mapStateToProps = state => {
    return {
        client: state.client.client,
        token: state.client.token
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateTheme: theme => dispatch(updateTheme(theme))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Customize);